// extracted by mini-css-extract-plugin
export default {"img":"profile_img__4oe-q","subtitle":"profile_subtitle__mC+-2","title":"profile_title__i-RmI","profile":"profile_profile__5CzlR","content":"profile_content__Dvs46"};